import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceDetailsChargesQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
  settledPaymentStatuses: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetInvoiceDetailsChargesQuery = { __typename?: 'query_root', arinvoices_by_pk?: { __typename?: 'arinvoices', id: number, invoice_type: string, status: string, accounting_num?: string | null, start_datetime: string, end_datetime: string, customer?: { __typename?: 'customers', id: number, auto_pay: boolean, billing_frequency: string, config?: object | null, effective_config?: object | null, name?: string | null, notify_billing?: boolean | null, payment_terms: number, organization?: { __typename?: 'organizations', id: number, config?: object | null } | null, paymentmethods: Array<{ __typename?: 'arpaymentmethods', id: number }> } | null, argroups: Array<{ __typename?: 'argroups', id: number, status: string, customer_id: number, program_id?: number | null, scenario_id?: number | null, createdat: string, algorithm_key?: string | null, run_metadata: object, customer: { __typename?: 'customers', id: number, name?: string | null }, archarges: Array<{ __typename?: 'archarges', id: number, name: string, notes?: string | null, amount: number, billable_datetime: string, accounting_key?: string | null, active: boolean, argroup_id: number, document_reference_id?: string | null, source_type?: string | null, source_id?: number | null, type: string, argroup: { __typename?: 'argroups', id: number, status: string, createdat: string }, documents: Array<{ __typename?: 'documents', id: number, mime_type: string, name: string, url: string }>, move?: Array<{ __typename?: 'moves', id: number, active: number, move_type: string, consumer_type?: string | null, class?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, reference_num?: string | null, status?: string | null, tags?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_odometer?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, cancel_status?: string | null, accessorials: Array<{ __typename?: 'accessorials', id: number, code: string, archarges?: Array<{ __typename?: 'archarges', id: number, name: string, amount: number, billable_datetime: string, accounting_key?: string | null, active: boolean, source_type?: string | null, source_id?: number | null, argroup: { __typename?: 'argroups', id: number, status: string, createdat: string }, arpaymentdetails: Array<{ __typename?: 'arpaymentdetails', id: number, amount: number, createdat: string, parent: { __typename?: 'arpayments', id: number, status: string } }> }> | null, arcredits?: Array<{ __typename?: 'arcredits', id: number, amount: number, reason: string, active: boolean, source_type?: string | null, source_id?: number | null, argroup: { __typename?: 'argroups', id: number, status: string, createdat: string } }> | null }>, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, region?: { __typename?: 'regions', id: number, accounting_class_num?: string | null } | null } } | null, raterule?: { __typename?: 'move_raterule', id?: number | null, rate?: number | null, type?: string | null, class?: string | null } | null, childMoves: Array<{ __typename?: 'moves', id: number, active: number, move_type: string, pickup_time?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null }, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, region?: { __typename?: 'regions', id: number, accounting_class_num?: string | null } | null } } | null, ridehails: Array<{ __typename?: 'ridehails', id: number, provider?: string | null, external_id?: string | null, product_type?: string | null }> }> }> | null, ridehail?: Array<{ __typename?: 'ridehails', id: number, provider?: string | null, status?: string | null, move?: { __typename?: 'moves', id: number, reference_num?: string | null, status?: string | null, move_type: string, consumer_type?: string | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null } | null } | null }> | null, guestride?: Array<{ __typename?: 'guestrides', id: number, reference_num?: string | null, status: string, guest_name: string, guest_phone: string, pickup_address?: string | null, dropoff_address?: string | null, provider?: string | null, created_at: string, ridehails: Array<{ __typename?: 'ridehails', id: number, provider?: string | null, external_id?: string | null, product_type?: string | null }> }> | null, arpaymentdetails: Array<{ __typename?: 'arpaymentdetails', id: number, amount: number, parent: { __typename?: 'arpayments', id: number, status: string, amount: number, createdat?: string | null } }> }>, arcredits: Array<{ __typename?: 'arcredits', id: number, amount: number, reason: string, active: boolean, argroup_id: number, source_type?: string | null, source_id?: number | null, createdat: string, move?: Array<{ __typename?: 'moves', id: number, reference_num?: string | null, status?: string | null, move_type: string, consumer_type?: string | null }> | null, guestride?: Array<{ __typename?: 'guestrides', id: number, reference_num?: string | null, status: string }> | null, accessorial?: Array<{ __typename?: 'accessorials', id: number, move_id: number, move: { __typename?: 'moves', id: number, reference_num?: string | null, status?: string | null, move_type: string, consumer_type?: string | null } }> | null, ridehail?: Array<{ __typename?: 'ridehails', id: number, move?: { __typename?: 'moves', id: number, reference_num?: string | null, status?: string | null, move_type: string, consumer_type?: string | null } | null }> | null }> }>, arpayments: Array<{ __typename?: 'arpayments', id: number, status: string, amount: number, accounting_id?: string | null, gateway_transaction_id?: string | null, createdat?: string | null, details: Array<{ __typename?: 'arpaymentdetails', id: number, archarge?: { __typename?: 'archarges', id: number, amount: number } | null }> }>, move_charges_aggregate: Array<{ __typename?: 'argroups', archarges: Array<{ __typename?: 'archarges', id: number, amount: number, arpaymentdetails_aggregate: { __typename?: 'arpaymentdetails_aggregate', aggregate?: { __typename?: 'arpaymentdetails_aggregate_fields', sum?: { __typename?: 'arpaymentdetails_sum_fields', amount?: number | null } | null } | null } }>, arcredits_aggregate: { __typename?: 'arcredits_aggregate', aggregate?: { __typename?: 'arcredits_aggregate_fields', sum?: { __typename?: 'arcredits_sum_fields', amount?: number | null } | null } | null } }>, product_charges_aggregate: Array<{ __typename?: 'argroups', archarges: Array<{ __typename?: 'archarges', id: number, amount: number, arpaymentdetails_aggregate: { __typename?: 'arpaymentdetails_aggregate', aggregate?: { __typename?: 'arpaymentdetails_aggregate_fields', sum?: { __typename?: 'arpaymentdetails_sum_fields', amount?: number | null } | null } | null } }> }> } | null };


export const GetInvoiceDetailsChargesDocument = gql`
    query getInvoiceDetailsCharges($invoiceId: bigint!, $settledPaymentStatuses: [String!]!) {
  arinvoices_by_pk(id: $invoiceId) {
    id
    invoice_type
    status
    accounting_num
    start_datetime
    end_datetime
    customer {
      id
      auto_pay
      billing_frequency
      config
      effective_config
      organization {
        id
        config
      }
      name
      notify_billing
      payment_terms
      paymentmethods(where: {type: {_eq: "manual"}}) {
        id
      }
    }
    argroups(order_by: {createdat: desc}, where: {status: {_eq: "done"}}) {
      id
      status
      customer_id
      program_id
      customer {
        id
        name
      }
      scenario_id
      createdat
      algorithm_key
      run_metadata
      archarges(
        where: {active: {_eq: true}, source_type: {_in: ["move", "guestride", "product", "scenario", "accessorial", "ridehail"]}}
        order_by: {billable_datetime: asc}
      ) {
        id
        name
        notes
        amount
        billable_datetime
        accounting_key
        active
        argroup_id
        argroup {
          id
          status
          createdat
        }
        document_reference_id
        documents {
          id
          mime_type
          name
          url
        }
        source_type
        source_id
        type
        move(where: {active: {_eq: 1}}) {
          id
          active
          move_type
          consumer_type
          class
          delivery_arrived
          delivery_started
          delivery_successful
          pickup_arrived
          pickup_started
          pickup_successful
          reference_num
          status
          tags
          vehicle_color
          vehicle_make
          vehicle_model
          vehicle_odometer
          vehicle_stock
          vehicle_vin
          vehicle_year
          cancel_status
          accessorials {
            id
            code
            archarges(where: {active: {_eq: true}}) {
              id
              name
              amount
              billable_datetime
              accounting_key
              active
              source_type
              source_id
              argroup {
                id
                status
                createdat
              }
              arpaymentdetails {
                id
                amount
                parent {
                  id
                  status
                }
                createdat
              }
            }
            arcredits(where: {active: {_eq: true}}) {
              id
              amount
              reason
              active
              source_type
              source_id
              argroup {
                id
                status
                createdat
              }
            }
          }
          customer {
            id
            name
          }
          lane {
            id
            description
            distance_miles
            delivery {
              id
              name
              address
            }
            pickup {
              id
              name
              address
              region {
                id
                accounting_class_num
              }
            }
          }
          raterule {
            id
            rate
            type
            class
          }
          childMoves(where: {active: {_eq: 1}, move_type: {_eq: "ride"}}) {
            id
            active
            move_type
            pickup_time
            delivery_arrived
            delivery_started
            delivery_successful
            pickup_arrived
            pickup_started
            pickup_successful
            lane {
              id
              description
              distance_miles
              delivery {
                id
                name
                address
              }
              pickup {
                id
                name
                address
                region {
                  id
                  accounting_class_num
                }
              }
            }
            ridehails(order_by: {created_at: desc}) {
              id
              provider
              external_id
              product_type
            }
          }
        }
        ridehail {
          id
          provider
          status
          move {
            id
            reference_num
            status
            move_type
            consumer_type
            lane {
              id
              description
              distance_miles
            }
          }
        }
        guestride {
          id
          reference_num
          status
          guest_name
          guest_phone
          pickup_address
          dropoff_address
          provider
          created_at
          ridehails(order_by: {created_at: desc}) {
            id
            provider
            external_id
            product_type
          }
        }
        arpaymentdetails {
          id
          amount
          parent {
            id
            status
            amount
            createdat
          }
        }
      }
      arcredits(where: {active: {_eq: true}}, order_by: {createdat: asc}) {
        id
        amount
        reason
        active
        argroup_id
        source_type
        source_id
        createdat
        move(where: {active: {_eq: 1}}) {
          id
          reference_num
          status
          move_type
          consumer_type
        }
        guestride {
          id
          reference_num
          status
        }
        accessorial {
          id
          move_id
          move {
            id
            reference_num
            status
            move_type
            consumer_type
          }
        }
        ridehail {
          id
          move {
            id
            reference_num
            status
            move_type
            consumer_type
          }
        }
      }
    }
    arpayments(order_by: {createdat: asc}) {
      id
      status
      amount
      accounting_id
      gateway_transaction_id
      createdat
      details(where: {archarge: {type: {_eq: "processing_fee"}}}) {
        id
        archarge {
          id
          amount
        }
      }
    }
    move_charges_aggregate: argroups(where: {status: {_eq: "done"}}) {
      archarges(
        where: {active: {_eq: true}, type: {_neq: "processing_fee"}, source_type: {_neq: "product"}}
      ) {
        id
        amount
        arpaymentdetails_aggregate(
          where: {parent: {status: {_in: $settledPaymentStatuses}}}
        ) {
          aggregate {
            sum {
              amount
            }
          }
        }
      }
      arcredits_aggregate(where: {active: {_eq: true}}) {
        aggregate {
          sum {
            amount
          }
        }
      }
    }
    product_charges_aggregate: argroups(where: {status: {_eq: "done"}}) {
      archarges(
        where: {active: {_eq: true}, type: {_neq: "processing_fee"}, source_type: {_eq: "product"}}
      ) {
        id
        amount
        arpaymentdetails_aggregate(
          where: {parent: {status: {_in: $settledPaymentStatuses}}}
        ) {
          aggregate {
            sum {
              amount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceDetailsChargesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDetailsChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDetailsChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDetailsChargesQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      settledPaymentStatuses: // value for 'settledPaymentStatuses'
 *   },
 * });
 */
export function useGetInvoiceDetailsChargesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables> & ({ variables: GetInvoiceDetailsChargesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>(GetInvoiceDetailsChargesDocument, options);
      }
export function useGetInvoiceDetailsChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>(GetInvoiceDetailsChargesDocument, options);
        }
// @ts-ignore
export function useGetInvoiceDetailsChargesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>;
export function useGetInvoiceDetailsChargesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceDetailsChargesQuery | undefined, GetInvoiceDetailsChargesQueryVariables>;
export function useGetInvoiceDetailsChargesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>(GetInvoiceDetailsChargesDocument, options);
        }
export type GetInvoiceDetailsChargesQueryHookResult = ReturnType<typeof useGetInvoiceDetailsChargesQuery>;
export type GetInvoiceDetailsChargesLazyQueryHookResult = ReturnType<typeof useGetInvoiceDetailsChargesLazyQuery>;
export type GetInvoiceDetailsChargesSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceDetailsChargesSuspenseQuery>;
export type GetInvoiceDetailsChargesQueryResult = Apollo.QueryResult<GetInvoiceDetailsChargesQuery, GetInvoiceDetailsChargesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/invoices/queries/getInvoiceDetailsCharges.query.gql}
 */
export async function getInvoiceDetailsCharges(
  variables: GetInvoiceDetailsChargesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetInvoiceDetailsChargesQuery['arinvoices_by_pk']>
export async function getInvoiceDetailsCharges(
  variables: GetInvoiceDetailsChargesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetInvoiceDetailsChargesQuery>
export async function getInvoiceDetailsCharges(
  variables: GetInvoiceDetailsChargesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetInvoiceDetailsChargesQuery['arinvoices_by_pk'] | GetInvoiceDetailsChargesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetInvoiceDetailsChargesQuery>(
    GetInvoiceDetailsChargesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arinvoices_by_pk
}